/**
 * API URL Configuration
 * Automatically routes to correct backend based on environment
 */
export const getApiUrl = () => {
  // Server-side rendering check (for Next.js)
  if (typeof window === 'undefined') {
    return process.env.NEXT_PUBLIC_API_URL || 'https://api.genanything.ai';
  }
  
  const hostname = window.location.hostname;
  
  console.log('[API Config] Detecting hostname:', hostname);
  console.log('[API Config] REACT_APP_API_URL env:', process.env.REACT_APP_API_URL);
  
  // Production frontend
  if (hostname === 'genanything.ai' || hostname === 'www.genanything.ai') {
    console.log('[API Config] Matched: Production');
    return 'https://api.genanything.ai';
  }
  
  // Development frontend
  if (hostname === 'dev.genanything.ai') {
    console.log('[API Config] Matched: Dev');
    return 'https://devapi.genanything.ai';
  }
  
  // Dev2 frontend (Clerk migration testing)
  if (hostname === 'dev2.genanything.ai') {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api-dev2.genanything.ai';
    console.log('[API Config] Matched: Dev2 → Using API URL:', apiUrl);
    return apiUrl;
  }
  
  // Local development - use dev API
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    console.log('[API Config] Matched: Localhost');
    return 'https://devapi.genanything.ai';
  }
  
  // Fallback to production
  console.warn(`[API Config] Unknown hostname: ${hostname}, defaulting to production`);
  return 'https://api.genanything.ai';
};

export const API_URL = getApiUrl();

// Always log API configuration for debugging
console.log('🔗 [API Config] Final API URL:', API_URL);
console.log('🌐 [API Config] Current Hostname:', typeof window !== 'undefined' ? window.location.hostname : 'SSR');
